const pagesGAOperationCoreOperationPackagesEn = {
  addPattern: 'Add Pattern',
  completed: 'Completed',
  displayDataAggregate: 'Display: Data Aggregate',
  emptyInstanceDescription: 'Create a new instance',
  emptyInstanceTitle: 'No running instances',
  emptyPackagePatternDescription: "Please register from the 'Add Operation Package Pattern' button.",
  emptyPackagePatternTitle: 'No operation package patterns',
  equipment: 'Equipment',
  equipmentInventoryLabel: {
    defaultPackageName: 'Unissued equipment',
    packageDescription: 'Issue equipment inventory labels through printing and attachment.',
    patternDescription: 'Issue inventory labels for unissued equipment through printing and attachment.'
  },
  failedToCompleteTask: 'Failed to complete task',
  failedToGenerateEquipmentLabel: 'Failed to generate equipment label',
  filterByPerson: 'Filter by person',
  gaOperationCore: 'GA Operation Core',
  instancesCount: '{{count}} instances',
  invalid: 'Invalid',
  markAsComplete: 'Mark as Complete',
  patternEmptyState: {
    action: 'Add Operation Package Pattern',
    description: "Please register from the 'Add Operation Package Pattern' button.",
    title: 'No operation package patterns'
  },
  progress: 'Progress',
  start: 'Start',
  startNew: 'Create New',
  startOperationTaskDialog: {
    anchorDate: 'Anchor Date',
    cancel: 'Cancel',
    cancelButtonLabel: 'Cancel',
    creationFailed: 'Failed to create operation instance',
    description: 'Select a target person and anchor date to start the operation.',
    equipmentInventoryLabelDescription: 'Configure settings for equipment inventory label issuance.',
    equipmentRequired: 'Please select equipment',
    equipmentSearchPlaceholder: 'Search by equipment name or asset tag',
    equipmentSelectionMode: {
      allUnissued: 'All unissued equipment',
      allUnissuedHelper: 'Processes up to 20 equipments without an inventory label per task. Create multiple tasks if you have more than 20.',
      selected: 'Selected equipment'
    },
    filterEquipments: 'Search by equipment name or asset tag',
    missingOperationPackageInstanceId: 'The operation instance was created but could not be opened. Please refresh and try again.',
    personRequired: 'Please select a person',
    personSearchPlaceholder: 'Search by name or email',
    selectPerson: 'Select Person',
    start: 'Start',
    startButtonLabel: 'Start',
    targetEquipment: 'Target Equipment',
    targetPerson: 'Target Person',
    title: 'Create New'
  },
  status: {
    approval: 'Approval',
    approvalRequired: 'Approval Required',
    attachment: 'Attachment',
    completed: 'Completed',
    notRequired: 'Not Required',
    todo: 'Prerequisite tasks incomplete'
  },
  successToCompleteTask: 'Task completed successfully',
  tabs: {
    archive: 'Archive',
    config: 'Configuration',
    operationPackages: 'Operation Packages'
  },
  taskColumns: {
    labelAttachment: 'Attach inventory labels',
    labelGeneration: 'Generate inventory labels',
    labelPrinting: 'Print inventory labels'
  },
  taskEmptyState: {
    description: "Click 'Create New' to start a new task.",
    title: 'No tasks'
  },
  taskProgress: 'Task Progress',
  viewData: 'View Data'
};
export default pagesGAOperationCoreOperationPackagesEn;